import { properties} from '#/properties.js';

import parse_georaster from "georaster"
import APIUtils from "#/lib/APIUtils";
import AuthenticationService from "#/lib/AuthenticationService";


export default class DataRequestClient {

	static getDataRequestsByStatus(okCallback, errCallback, status = 'ALL' ){
		let url = new URL(properties.url.dataRequests + status);
	/*	let url = properties.url.dataRequests + (status || '');*/
		APIUtils.getFetchResponse(url, null, okCallback, errCallback);
	}
	static save = (okCallback, errCallback, request) => {
		let url = properties.url.saveDataRequest;

		let fetch_options = {
			headers: {'Content-Type': 'application/json', 'charset': 'utf-8'},
			method: 'POST',
			body: JSON.stringify(request)
		}
		APIUtils.getFetchResponse(url, fetch_options, okCallback, errCallback);
	}
}
